import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import Opponents from '../../Opponents';

const MODIFIER_GROUP = 'modifier';
const DEFAULT_OPTION_VALUE = 'ANY';
const PRIMARY_FIELDER_OPTION_VALUE = 'PRIMARY_FIELDER';
const ON_FIRST_OPTION_VALUE = 'ON_FIRST';
const ON_SECOND_OPTION_VALUE = 'ON_SECOND';
const ON_THIRD_OPTION_VALUE = 'ON_THIRD';
const BATTING_OPTION_VALUE = 'BATTING';
const PITCHING_OPTION_VALUE = 'PITCHING';
const PRIMARY_FIELDER_OPTION = {
    label: 'Primary Fielder',
    value: PRIMARY_FIELDER_OPTION_VALUE,
};
const ON_FIRST_OPTION = {
    label: 'On 1st Base',
    value: ON_FIRST_OPTION_VALUE,
};
const ON_SECOND_OPTION = {
    label: 'On 2nd Base',
    value: ON_SECOND_OPTION_VALUE,
};
const ON_THIRD_OPTION = {
    label: 'On 3rd Base',
    value: ON_THIRD_OPTION_VALUE,
};
const BATTING_OPTION = {
    label: 'Batting',
    value: BATTING_OPTION_VALUE,
};
const PITCHING_OPTION = {
    label: 'Pitching',
    value: PITCHING_OPTION_VALUE,
};
const ANY_OPTION = {
    label: 'Any',
    value: DEFAULT_OPTION_VALUE,
};
const defaultParticipantState = {
    [MODIFIER_GROUP]: ANY_OPTION,
};
const modifiers = {
    [MODIFIER_GROUP]: [
        BATTING_OPTION,
        PITCHING_OPTION,
        PRIMARY_FIELDER_OPTION,
        ANY_OPTION,
        ON_FIRST_OPTION,
        ON_SECOND_OPTION,
        ON_THIRD_OPTION,
    ],
};

const Players = (props) => {

    const {
        componentConfig,
        fields,
        onChange,
    } = props;

    const {
        suggestionsKey = 'players',
        placeholder = 'Select Player Name',
        typeaheadFieldId = 166,
        playerFieldId = 165,
        battingFieldId = 3,
        pitchingFieldId = 32,
        primaryFielderFieldId = 53,
        onFirstFieldId = 139,
        onSecondFieldId = 140,
        onThirdFieldId = 141,
    } = componentConfig;

    const {
        defaultField,
        modifierFieldMap,
        stateFieldMap,
    } = useMemo(() => {

        const defaultField = fields.find(field => Number(field.id) === playerFieldId);

        const modifierFieldMap = {
            [MODIFIER_GROUP]: {
                [DEFAULT_OPTION_VALUE]: defaultField,
                [BATTING_OPTION_VALUE]: fields.find(field => Number(field.id) === battingFieldId),
                [PITCHING_OPTION_VALUE]: fields.find(field => Number(field.id) === pitchingFieldId),
                [PRIMARY_FIELDER_OPTION_VALUE]: fields.find(field => Number(field.id) === primaryFielderFieldId),
                [ON_FIRST_OPTION_VALUE]: fields.find(field => Number(field.id) === onFirstFieldId),
                [ON_SECOND_OPTION_VALUE]: fields.find(field => Number(field.id) === onSecondFieldId),
                [ON_THIRD_OPTION_VALUE]: fields.find(field => Number(field.id) === onThirdFieldId),
            },
        };

        const stateFieldMap = {
            [battingFieldId]: {
                stateProp: MODIFIER_GROUP,
                option: BATTING_OPTION,
            },
            [pitchingFieldId]: {
                stateProp: MODIFIER_GROUP,
                option: PITCHING_OPTION,
            },
            [primaryFielderFieldId]: {
                stateProp: MODIFIER_GROUP,
                option: PRIMARY_FIELDER_OPTION,
            },
            [onFirstFieldId]: {
                stateProp: MODIFIER_GROUP,
                option: ON_FIRST_OPTION,
            },
            [onSecondFieldId]: {
                stateProp: MODIFIER_GROUP,
                option: ON_SECOND_OPTION,
            },
            [onThirdFieldId]: {
                stateProp: MODIFIER_GROUP,
                option: ON_THIRD_OPTION,
            },
        };

        return {
            defaultField,
            modifierFieldMap,
            stateFieldMap,
        };

    });

    return (
        <Opponents
            defaultField={defaultField}
            defaultParticipantState={defaultParticipantState}
            defaultOptionValue={DEFAULT_OPTION_VALUE}
            modifierFieldMap={modifierFieldMap}
            modifiers={modifiers}
            stateFieldMap={stateFieldMap}
            suggestionsKey={suggestionsKey}
            placeholder={placeholder}
            typeaheadFieldId={typeaheadFieldId}
            onChange={onChange}
            componentConfig={componentConfig}
            fields={fields}
            topHeader={'Player 1'}
            bottomHeader={'Player 2'}
            removeOpponentLabel={'Remove Player 2'}
        />
    );

};

Players.propTypes = {
    componentConfig: PropTypes.object.isRequired,
    fields: PropTypes.arrayOf(
        PropTypes.shape({
            selected: PropTypes.array.isRequired,
        }).isRequired
    ).isRequired,
    onChange: PropTypes.func.isRequired,
};

export default Players;
